import { Injectable, ApplicationRef } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import Swal from "sweetalert2";
import { AuthenticationService } from "./auth.service";
import { Router, NavigationEnd } from "@angular/router";

@Injectable({
    providedIn: "root",
})
export class CheckupdateService {
    userDetail: any;

    constructor(
        private readonly updates: SwUpdate,
        private authenticationService: AuthenticationService,
        private router: Router
    ) {
        if (this.updates.isEnabled) {
            // setInterval(() => {
            //     updates.checkForUpdate().then(() => {
            //         this.isAvailable();
            //     });
            // }, 30000);
        }
    }

    getUpdate() {
        // if (this.updates.isEnabled) {
        //     this.isAvailable();
        // }else {
        // }
        setInterval(() => {
            this.iscekLogin();
        }, 2500);
    }

    isAvailable() {
        if (this.updates.isEnabled) {
            this.updates.available.subscribe((event) => {
                this.showAppUpdateAlert();
            });
            // this.updates.checkForUpdate().then((event) => {
            // });
        }else{
        }
    }

    iscekLogin() {
        this.userDetail = this.authenticationService.getDetailUser();
        if (this.userDetail) {
        } else {
            var routing =  this.router.url.split('/',3); 
            var urlCustom = '/'+routing[1]+'/'+ routing[2];
            if (
                this.router.url == "/account/login?returnUrl=%2Fhome" ||
                this.router.url == "/" ||
                this.router.url == "/account/login" ||
                urlCustom == "/account/reset-password" || 
                urlCustom == "/account/verifikasi-demo"
            ) {
                if (this.userDetail) {
                    window.location.href = "/home";
                } else {
                    // Do Nothing
                }
            } else {
                localStorage.removeItem('userDetail');
                window.location.href = "/account/login";
            }
        }
    }

    showAppUpdateAlert() {
        // Use MatDialog or ionicframework's AlertController or similar
        Swal.fire({
            title: "Perhatian",
            text:
                "Terdapat pembaruan pada sistem, silahkan klik Perbarui Sistem ",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Perbarui Sistem",
        }).then((result) => {
            if (result.value) {
                this.doAppUpdate();
            }
        });
    }

    doAppUpdate() {
        this.updates.activateUpdate().then(() => document.location.reload());
    }
}
